import { Injectable } from "@angular/core";
import { ApiHttpService } from "./api-http.service";
import { Observable } from "rxjs";

@Injectable()
export class GeNameValidationService {
  constructor(private apiHttp: ApiHttpService) {}

  public validateGeName = (
    criteria: GeNameValidationCriteriaModel
  ): Observable<GeNameValidationResult> => {
    return this.apiHttp.post<GeNameValidationResult>(
      "geneticelementqueries",
      criteria
    );
  };
}

export interface GeNameValidationCriteriaModel {
  geName: string;
}

export interface GeNameValidationResult {
  geName: string;
  valid: boolean;
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/services/ge-name-validation.service.ts